module.exports = __webpack_public_path__ + "img/Group 212.f0c5e096.png";